export const CONTACT_EMAIL = "contact@coval-tech.com";

export const SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/company/covaltechsrl",
  github: "https://github.com/covaltech",
} as const;

